<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'create'">{{aLang.c_create}} {{aLang.gdmm_user}}</span>
        <span v-if="mData.viewMode == 'update'">{{aLang.c_update}} {{aLang.gdmm_user}}</span>
        <span v-if="mData.viewMode == 'detail'">{{aLang.c_detail}} {{aLang.gdmm_user}}</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row>            
            <b-col md="6">
              <el-form-item :label="aLang.gdmm_current_user" prop="id">
                <el-select
                  v-model="mData.dataForm.id"
                  :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'detail'||mData.viewMode == 'update'"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in mData.dataDefault.listNguoiDung"
                    :key="item.id"
                    :label="item.account"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>           
            <b-col md="6">
              <el-form-item :label="aLang.gdmm_superior" prop="parent_id">
                <el-select
                  v-model="mData.dataForm.parent_id"
                  :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in mData.dataDefault.listNguoiDung"
                    :key="item.id"
                    :label="item.account"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>           
          </b-row>

          <b-row>
            
            <b-col md="12"> 
              <el-form-item :label="aLang.gdmm_subordinates" prop="children">
                <el-select
                  v-model="mData.dataForm.children"
                  :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  multiple
                  filterable
                >
                  <el-option
                    v-for="item in mData.dataDefault.listNguoiDung"
                    :key="item.id"
                    :label="item.account"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
          </b-row>          

          <el-form-item class="text-center mt-3">
            <el-button
              type="info"
              plain
              @click="fn_submitForm('create')"
              v-ladda
              v-if="mData.viewMode == 'create'"
            >{{aLang.c_create}}</el-button>

            <el-button
              type="info"
              plain
              @click="fn_submitForm('update')"
              v-ladda
              v-if="mData.viewMode == 'update'"
            >{{aLang.c_update}}</el-button>

            <el-button @click="fn_go()" type="info" plain>{{aLang.c_back}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import ExtensionService from "../../../service/ExtensionService";
import NguoiDungTcqlttModel from "./NguoiDungTcqlttModel";
import NguoiDungTcqlttApi from "../../../moduleApi/NguoiDungTcqlttApi";
import AccountApi from "../../../moduleApi/AccountApi";


export default {
  data() {
    return {
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "NguoiDungTcqltt",
        dataDefault: {          
          listNguoiDung: [],  
            
        },
        dataForm: MethodService.copyObject(NguoiDungTcqlttModel.dataForm),
        validForm: NguoiDungTcqlttModel.validForm,        
        dialog: {}
      }
    };
  },
  methods: {
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async valid => {
        if (valid) {
          if (type == "create") {
            // let currentUser=MethodService.getCurrentUser();
            // this.mData.dataForm.id=currentUser.id;

            // if (this.mData.dataForm.id==currentUser.id){
            //   toast.error("Đã thiết lập cho người dùng này");
            // }
            // else{

            // }
            await NguoiDungTcqlttApi.create(this.mData.dataForm);
            this.fn_resetForm();
          }
          if (type == "update") {
            this.mData.dataForm.id = this.$router.currentRoute.params.id;
            await NguoiDungTcqlttApi.update(this.mData.dataForm);

            $.each(this.mData.dataForm.children, async (index, item) => {
       
              let child=MethodService.copyObject(NguoiDungTcqlttModel.dataForm);
              child.id=item;
              child.parent_id=this.mData.dataForm.id;
              let resChild=await NguoiDungTcqlttApi.findById(item);      
        
              if (resChild && resChild.result){
                await NguoiDungTcqlttApi.update(child);
           
              }
              else{
                await NguoiDungTcqlttApi.create(child);
              
              }
              
            });

            this.fn_go(-1);
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_resetForm() {
      
      this.$refs["myForm"].resetFields();
    },
    fn_go() {
      this.$router.go(-1);
    },
    async fn_getDataById(id) {
      let res = await NguoiDungTcqlttApi.findById(id);
      let resData = MethodService.checkDifferentObject(MethodService.copyObject(NguoiDungTcqlttModel.dataForm), res.result);      
      this.mData.dataForm = resData;
    },
    async fn_initDataDefault() {    
                   
      let resNguoiDung = await AccountApi.list({ filters: 'roles:in:TCQLTT' });
      this.mData.dataDefault.listNguoiDung = resNguoiDung.result;
      
      let currentUser=MethodService.getCurrentUser();
      this.mData.dataForm.id=currentUser.id;        

    },

    
  },
  created: function() {
    this.fn_initDataDefault();
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    }
    if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
  mounted: function() {}
};
</script>